import { SubmissionError } from '#helper/submission-error';
import {
  FETCH_PROJECT_CUSTOM_FIELD_STARTED,
  FETCH_PROJECT_CUSTOM_FIELD_SUCCEEDED,
  FETCH_PROJECT_CUSTOM_FIELD_FAILED,
  FETCH_PROJECT_CUSTOM_FIELD_CLEAR
} from '#action/types';
import { webPortalApi } from '#config/web-portal-api';
import { snackBarError } from '#action/fetch';
import { getRequestOptions } from '#helper';

let abortController = new AbortController();

export const fetchProjectCustomFields = projectId => async dispatch => {
  try {
    abortController.abort();

    dispatch({
      type: FETCH_PROJECT_CUSTOM_FIELD_STARTED
    });

    abortController = new AbortController();
    const { signal } = abortController;

    const url = webPortalApi.buildApiUrl(`project/${projectId}/custom-field`);
    const res = await fetch(url, { ...getRequestOptions(), signal });
    const contentType = res.headers.get('content-type');

    if (!contentType || !contentType.includes('application/json')) {
      throw new TypeError('Response is not json');
    }

    if (!res.ok) {
      const response = await res.json();
      dispatch({
        type: FETCH_PROJECT_CUSTOM_FIELD_FAILED,
        error: response
      });
      return dispatch(
        snackBarError({
          message: 'Error in request',
          ...response
        })
      );
    }
    const data = await res.json();

    return dispatch({
      type: FETCH_PROJECT_CUSTOM_FIELD_SUCCEEDED,
      payload: data
    });
  } catch (e) {
    if (e.name === 'AbortError') {
      return false;
    }
    console.error(e);
    return dispatch({
      type: FETCH_PROJECT_CUSTOM_FIELD_FAILED,
      error: e
    });
  }
};

export const putProjectCustomFields = (id, customFields) => async dispatch => {
  try {
    const res = await fetch(webPortalApi.buildApiUrl(`project/${id}/custom-field`), {
      method: 'PUT',
      body: JSON.stringify(customFields),
      ...getRequestOptions()
    });
    const response = await res.json();

    if (!res.ok) {
      dispatch(
        snackBarError({
          message: 'Error in request',
          ...response
        })
      );
      throw new SubmissionError(response);
    }

    return { success: true };
  } catch (e) {
    return { success: false };
  }
};

export const clearProjectCustomFields = () => async dispatch => {
  dispatch({ type: FETCH_PROJECT_CUSTOM_FIELD_CLEAR });
};
